import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { PARAGRAPH_BLOCK_TYPES } from "../../shared/chapterParagraphs";

function createParagraphId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `p_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

/** Paragraph/heading blocks carry stable `id` attrs for cross-platform references. */
export const ParagraphIds = Extension.create({
  name: "paragraphIds",

  addGlobalAttributes() {
    return [
      {
        types: [...PARAGRAPH_BLOCK_TYPES],
        attributes: {
          id: {
            default: null,
            parseHTML: (element) => element.getAttribute("data-paragraph-id"),
            renderHTML: (attributes) => {
              if (!attributes.id) return {};
              return { "data-paragraph-id": attributes.id };
            },
          },
        },
      },
    ];
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("paragraphIds"),
        appendTransaction(_transactions, _oldState, newState) {
          const tr = newState.tr;
          let changed = false;
          newState.doc.descendants((node, pos) => {
            if (!PARAGRAPH_BLOCK_TYPES.has(node.type.name)) return;
            const currentId = node.attrs.id;
            if (typeof currentId === "string" && currentId.trim()) return;
            tr.setNodeMarkup(pos, undefined, { ...node.attrs, id: createParagraphId() });
            changed = true;
          });
          return changed ? tr : null;
        },
      }),
    ];
  },
});

export default ParagraphIds;
